import { useMutation } from '@apollo/client';
import {
    ModalContent,
    ModalTitle,
    PrimaryButton,
    ResponsiveSidebarDialog,
    SecondaryButton,
    StickyModalActions,
} from '@/styles/blocks';
import { css } from '@emotion/react';
import { captureException } from '@sentry/react';
import { Grid } from '@material-ui/core';
import { Body1 } from '../../blocks';
import { UPDATE_CLAIM } from '../../ClaimDetails/graphql';
import { useContext } from 'react';
import { UserContext } from '@/components/App';

const ConfirmReopenModal = ({ claim, open, onClose, onSave, callbacks }) => {
    const { user } = useContext(UserContext);

    const [updateClaim, { loading: saveInFlight }] = useMutation(UPDATE_CLAIM, {
        onError: (error) => {
            console.error(error);
            captureException(error);
            callbacks.setNotification({
                severity: 'error',
                message: `Failed to update claim. ${error.message}`,
            });
        },
    });

    const reOpenClaim = () => {
        updateClaim({
            variables: {
                claim_id: claim.claim_id,
                update: {
                    claim_status: 'INVESTIGATING',
                    reopened_at: new Date().toISOString(),
                    reopened_by: user.user_id,
                },
            },
        }).then(() => {
            onSave();
        });
    };

    return (
        <ResponsiveSidebarDialog open={open} onClose={onClose}>
            <ModalTitle title={'Re-Open Claim?'} onClose={onClose} />
            <ModalContent
                css={css`
                    width: 400px;
                `}
            >
                <Grid container direction="column" css={css``}>
                    <Grid item>
                        <Body1>Click "Confirm" below to re-open the claim for further investigation.</Body1>
                    </Grid>
                </Grid>
            </ModalContent>
            <StickyModalActions>
                <Grid item>
                    <SecondaryButton disabled={saveInFlight} onClick={onClose}>
                        Cancel
                    </SecondaryButton>
                </Grid>
                <Grid item>
                    <PrimaryButton red disabled={saveInFlight} onClick={reOpenClaim}>
                        Confirm
                    </PrimaryButton>
                </Grid>
            </StickyModalActions>
        </ResponsiveSidebarDialog>
    );
};

export default ConfirmReopenModal;
